import axios from "./axios";

const getFooterLinks = () =>
  axios.get(`/users/footer/`).then(
    (res) => res,
    (err) => err.response
  );

export { getFooterLinks };